(function () {
  // Variant IDs of all products in /collections/sets
  var SET_VARIANT_IDS = [
    698714849281,    // Moisture Surge System
    32806929498159,  // The Complete Afrocenchix Routine
    698716749825,    // The Healthy Hair Starter Kit
    31339453087791,  // Complete Wash Day Routine
    835023962113,    // Curl Discovery Kit
    42131897679919,  // Twist & Define Styling Kit
    45168474685487,  // Fortify & Grow System
    45168474619951,  // Repair & Restore Treatment Set
    45168474488879   // Protective Style Care Kit
  ];

  // Free items to auto-add when a set is in cart
  var FREE_ITEM_VARIANT_IDS = [
    30360998337,     // Mini Swish
    30360987969,     // Mini Smooth
    31313898831919,  // Mini Swirl
    45558535389231   // African Print Travel Bag
  ];

  var SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  var isHandling = false;

  function getCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function hasSetInCart(cart) {
    return cart.items.some(function (item) {
      return SET_VARIANT_IDS.indexOf(item.variant_id) !== -1;
    });
  }

  function freeItemsInCart(cart) {
    return cart.items.filter(function (item) {
      return FREE_ITEM_VARIANT_IDS.indexOf(item.variant_id) !== -1;
    });
  }

  // Fetch fresh section HTML and re-render the mini-cart drawer in-place.
  function refreshMiniCart() {
    var miniCart = document.querySelector('mini-cart');
    if (!miniCart) { location.reload(); return; }

    fetch(window.location.pathname + '?sections=' + SECTIONS.join(','))
      .then(function (res) { return res.json(); })
      .then(function (sectionData) {
        miniCart.renderContents({ sections: sectionData });
      })
      .catch(function () { location.reload(); });
  }

  function handleSetGWP() {
    if (isHandling) return;
    isHandling = true;

    getCart().then(function (cart) {
      var setPresent = hasSetInCart(cart);
      var presentFreeItems = freeItemsInCart(cart);

      if (!setPresent) {
        // No set in cart — remove any free items that are there
        if (presentFreeItems.length === 0) {
          isHandling = false;
          return;
        }

        Promise.all(presentFreeItems.map(function (item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        })).then(function () {
          isHandling = false;
          refreshMiniCart();
        }).catch(function () { isHandling = false; });

        return;
      }

      // Set is in cart — find which free items are missing
      var presentVariantIds = presentFreeItems.map(function (i) { return i.variant_id; });
      var missingItems = FREE_ITEM_VARIANT_IDS.filter(function (vid) {
        return presentVariantIds.indexOf(vid) === -1;
      });

      if (missingItems.length === 0) {
        isHandling = false;
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: missingItems.map(function (vid) { return { id: vid, quantity: 1 }; })
        })
      }).then(function () {
        isHandling = false;
        refreshMiniCart();
      }).catch(function () { isHandling = false; });

    }).catch(function () {
      isHandling = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    handleSetGWP();

    // Watch the mini-cart element for DOM updates (covers homepage add-to-cart
    // paths that don't publish the cart-update pub/sub event).
    var miniCartContent = document.getElementById('mini-cart');
    if (miniCartContent) {
      var observer = new MutationObserver(function () {
        handleSetGWP();
      });
      observer.observe(miniCartContent, { childList: true });
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleSetGWP);
  }
})();
